<form [formGroup]="subcomponentGroup" (ngSubmit)="onSubmit()">
    <div class="title-outer">
        <h2 class="form-title">{{ languageService.languageJSON.ComponentVariant_Title }}</h2>
    </div>

    <app-loading-animation class="edit-animation" *ngIf="loading"></app-loading-animation>

    <div class="form-section" [hidden]="loading">
        <div class="flex-outer">
            <div class="flex-col">
                <div class="flex-row">
                    <label required>{{ languageService.languageJSON.ConfigurationDetails_OE }}:</label>
                    <mat-select required *ngIf="oeOptionsList" formControlName="oem"
                        (selectionChange)="updateComponentList()">
                        <mat-option *ngFor="let oe of oeOptionsList" [value]="oe.id">{{ oe.name }}</mat-option>
                    </mat-select>
                </div>

                <div class="flex-row" *ngIf="oem?.invalid && oem?.touched">
                    <h5 class="error">
                        {{ languageService.languageJSON.ConfigurationDetails_OE }}
                        {{ languageService.languageJSON.Form_Required_Error }}
                    </h5>
                </div>

                <div class="flex-row double-selector-row" [hidden]="oem?.value==''">
                    <label required>{{ languageService.languageJSON.ReleaseDetails_TargetBikeComponent }}:</label>
                    <div class="flex-col">
                        <div class="double-selector">
                            <mat-select required *ngIf="componentClassOptionsList" formControlName="componentClass"
                                (selectionChange)="updateComponentList()">
                                <mat-option *ngFor="let componentClassOption of componentClassOptionsList"
                                    [value]="componentClassOption.id" selected>{{ componentClassOption.name }}</mat-option>
                            </mat-select>
                            <mat-select required *ngIf="componentList.length>0" formControlName="component">
                                <mat-option *ngFor="let componentEl of componentList"
                                    [value]="componentEl.Id" [attr.tenant]="componentEl.OEMName"
                                    selected>{{
                                    componentEl.ComponentName }}</mat-option>
                            </mat-select>
                            <label *ngIf="componentList.length==0">{{
                                languageService.languageJSON.ConfigurationDetails_NoOption }}</label>
                        </div>
                    </div>
                </div>

                <div class="flex-row" *ngIf="component?.invalid && component?.touched" [hidden]="oem?.value==''">
                    <h5 class="error">
                        {{ languageService.languageJSON.ReleaseDetails_TargetBikeComponent }}
                        {{ languageService.languageJSON.Form_Required_Error }}
                    </h5>
                </div>

                <div class="flex-row" [hidden]="oem?.value==''">
                    <label required>{{ languageService.languageJSON.ComponentVariant_ComponentVariant }}:</label>
                    <input type="text" required formControlName="componentVariant">
                </div>

                <div class="flex-row" [hidden]="oem?.value==''"
                    *ngIf="componentVariant?.invalid && componentVariant?.touched">
                    <h5 class="error">
                        {{ languageService.languageJSON.ComponentVariant_ComponentVariant }}
                        {{ languageService.languageJSON.Form_Required_Error }}
                        {{ languageService.languageJSON.Form_Length_Error.replace("$X",
                        settingsService.getTitleMaxLength()) }}
                    </h5>
                </div>
            </div>
        </div>
    </div>

    <div class="form-section-send" [hidden]="loading">
        <button type="submit">
            {{ languageService.languageJSON.Global_Save}}
        </button>
        <button class="back-button" (click)="goBack()">{{ languageService.languageJSON.Global_Cancel}}</button>
    </div>
</form>